// Regras de validação do redirecionamento.
// O link da Actionpay é cadastrado terminando com o marcador "subaccount",
// que é substituído pelo ID do influenciador para atribuir a comissão.

// ID de influenciador: só dígitos, mínimo 4, sem zero à esquerda (gerado a partir de ~1001)
const PADRAO_ID_INFLUENCIADOR = /^[1-9]\d{3,}$/;

// Link base: endereço https terminando com o marcador onde entra o ID
const PADRAO_LINK_BASE = /^https?:\/\/.*subaccount$/;

export function idInfluenciadorValido(id: string | undefined): id is string {
    return !!id && PADRAO_ID_INFLUENCIADOR.test(id);
}

export function linkBaseValido(linkBase: string): boolean {
    return PADRAO_LINK_BASE.test(linkBase);
}

export function montarLinkFinal(linkBase: string, idInfluenciador: string): string {
    return linkBase.replace(/subaccount$/, () => idInfluenciador);
}
